import { Input, UiButton, UiText } from '@shared/ui';

import cls from './PasswordSettings.module.css';
import { usePasswordSettings } from '../../model/usePasswordSettings';

export const PasswordSettings = () => {
    const { t, values, errors, updateValue, handleSubmit, isPending } = usePasswordSettings();

    return (
        <section className={cls.settingsSection}>
            <UiText tag="h3" variant="subHeading" weight="bold">
                {t('profile.page.settings.password.title')}
            </UiText>
            <form className={cls.passwordForm} onSubmit={handleSubmit}>
                <div className={cls.passwordFields}>
                    <Input
                        name="profile-current-password"
                        type="password"
                        value={values.oldPassword}
                        onChange={(event) => updateValue('oldPassword', event.target.value)}
                        placeholder={t('profile.page.settings.password.current')}
                        aria-label={t('profile.page.settings.password.current')}
                        classes={[cls.inputWrapper]}
                        error={errors.oldPassword}
                    />
                    <Input
                        name="profile-new-password"
                        type="password"
                        value={values.password}
                        onChange={(event) => updateValue('password', event.target.value)}
                        placeholder={t('profile.page.settings.password.new')}
                        aria-label={t('profile.page.settings.password.new')}
                        classes={[cls.inputWrapper]}
                        error={errors.password}
                    />
                    <Input
                        name="profile-new-password-confirmation"
                        type="password"
                        value={values.passwordConfirmation}
                        onChange={(event) =>
                            updateValue('passwordConfirmation', event.target.value)
                        }
                        placeholder={t('profile.page.settings.password.confirmation')}
                        aria-label={t('profile.page.settings.password.confirmation')}
                        classes={[cls.inputWrapper]}
                        error={errors.passwordConfirmation}
                    />
                </div>
                {errors.form && (
                    <UiText role="alert" className={cls.formError}>
                        {errors.form}
                    </UiText>
                )}
                <UiButton
                    type="submit"
                    className={cls.settingsAction}
                    btnText={t('profile.page.settings.password.submit')}
                    disabled={isPending}
                />
            </form>
        </section>
    );
};
